import React from 'react';
import LessonForm from '@components/lessonForm/LessonForm';
import { useGetCurrentUserQuery } from '@teachur/http-client';

const EditLesson = () => {
  const { data: user } = useGetCurrentUserQuery();

  if (!user) {
    return null;
  }

  return <LessonForm lesson={{ id: -1 }} />;
};

export default EditLesson;
